// Detect synchronously whether the current checkout is hotel, aéreo, or marketplace based on the ?checkout= search param (with location.state fallback). Source of truth: src/page/OrderResumePag/index.js:937-957.

function readCheckoutParam(searchParams, location) {
  const fromParams = searchParams?.get?.("checkout");
  if (fromParams) return String(fromParams).toLowerCase();

  const searchString = location?.search;
  const fromSearch = new URLSearchParams(searchString || "").get("checkout");
  if (fromSearch) return String(fromSearch).toLowerCase();

  const stateHint = location?.state?.checkout;
  if (stateHint) return String(stateHint).toLowerCase();

  return null;
}

export function detectCheckoutKind({ location, searchParams } = {}) {
  const kind = readCheckoutParam(searchParams, location);

  return {
    isHotelCheckout: kind === "hotel",
    isAereoCheckout: kind === "aereo",
  };
}
